import { AppsV1NavigationMenuItem } from '../types';

export const PAYMENTS_OVERVIEW_MENU_ID = 'Zuora/Payments/PaymentsOverview';
export const PAYMENTS_INSIGHTS_PATH = '/platform/apps/payments/insights';

export const rewritePaymentsOverviewMenuUrl = (
  menus: AppsV1NavigationMenuItem[] | undefined,
  hasPaymentOrchestrationPermission: boolean,
  toAbsoluteUrl: (path: string) => string = (path) => path,
  insightsLabel?: string,
): AppsV1NavigationMenuItem[] | undefined => {
  if (!menus) {
    return menus;
  }

  if (!hasPaymentOrchestrationPermission) {
    return menus;
  }

  return menus.map((menu) =>
    menu.id === PAYMENTS_OVERVIEW_MENU_ID
      ? {
          ...menu,
          url: toAbsoluteUrl(PAYMENTS_INSIGHTS_PATH),
          ...(insightsLabel ? { label: insightsLabel } : {}),
        }
      : menu,
  );
};
